<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    right
    class="hidden-lg-and-up"
  >
    <v-list nav>
      <v-list-item-group
        active-class="accent--text text--accent"
      >
        <!-- Top -->
        <v-list-item
          v-for="top in topBarItems"
          :key="top.icon"
          :to="top.link"
        >
          <v-list-item-icon>
            <v-icon>{{ top.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ top.item }}</v-list-item-title>
        </v-list-item>

        <!-- Main -->
        <v-list-item
          v-for="main in mainBarItems"
          :key="main.icon"
          :to="main.link"
        >
          <v-list-item-icon>
            <v-icon>{{ main.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ main.item }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: "BaseNavigationDrawer",

    props: {
      value: { type: Boolean, default: false }
    },

    data() {
      return {
        drawer: this.value,
        mainBarItems: [
           {
            item: "Shop",
            icon: 'mdi-cart',
            link: "/shop"
          },
        ],
        topBarItems: [
          // // {
          // //   item: "Member Login",
          // //   icon: 'mdi-account',
          // //   link: "/login"
          // // },
          // {
          //   item: "Contact Us",
          //   icon: 'mdi-phone',
          //   link: "/contact"
          // }
        ],
        // mainBarItems: [
        //   {
        //     item: "Medgate App",
        //     icon: 'mdi-cellphone',
        //     link: "/medgate-app"
        //   },
        //   {
        //     item: "Media",
        //     icon: 'mdi-newspaper-variant-outline',
        //     link: "/media"
        //   },
        //   {
        //     item: "Shop",
        //     icon: 'mdi-cart',
        //     link: "/shop"
        //     // link: [
        //     //   {
        //     //     subItem: "Shop Assignment",
        //     //     subLink: "/shop/assignment"
        //     //   },
        //     //   {
        //     //     subItem: "Shop Checkout",
        //     //     subLink: "/shop/checkout"
        //     //   }
        //     // ]
        //   },
        //   {
        //     item: "Business",
        //     icon: 'mdi-handshake',
        //     link: "/business"
        //     // link: [
        //     //   {
        //     //     subItem: "For Doctors",
        //     //     subLink: "/"
        //     //   },
        //     //   {
        //     //     subItem: "Job Vacancies",
        //     //     subLink: "/"
        //     //   }
        //     // ]
        //   },
        //   {
        //     item: "Jobs",
        //     icon: 'mdi-briefcase',
        //     link: "/jobs"
        //     // link: [
        //     //   {
        //     //     subItem: "For Doctors",
        //     //     subLink: "/"
        //     //   },
        //     //   {
        //     //     subItem: "Job Vacancies",
        //     //     subLink: "/"
        //     //   }
        //     // ]
        //   },
        //   {
        //     item: "About",
        //     icon: 'mdi-information-outline',
        //     link: "/about"
        //   }
        // ],
      }
    },
    
    watch: {
      value(val) {
        this.drawer = val;
      },
      drawer(val) {
        this.$emit('input', val);
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>